import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { TradingAccountFilterKey } from 'api/Clients/Types/TradingAccount'
import { WelcomeTradingAccountFilterKey } from 'api/Trading-Accounts/Types/WelcomeTradingAccountDto'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { BooleanFilter } from './BooleanFilter'
import {
  CountryFilter,
  CustomDateFilter,
  MultiCompanySelectFilter,
  PlatformFilter,
} from './common.filter'
import { TradingDemoAccountGroupFilter } from './TradingAccountFields/TradingAccountGroupFilter'
import { TradingAccountStatusFilter } from './TradingAccountFields/TradingAccountStatusFilter'

const getTradingAccountDemoFilterFields = (): FieldSettings[] => [
  {
    name: TradingAccountFilterKey.externalID,
    label: 'External ID',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.startsWithOperator,
        operator: GridFilterOperatorEnum.startsWithOperator,
      },
    ],
  },
  {
    name: WelcomeTradingAccountFilterKey.name,
    label: 'Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
    ],
  },
  {
    name: WelcomeTradingAccountFilterKey.accountGroup,
    label: 'Account Group',
    filter: TradingDemoAccountGroupFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: TradingAccountFilterKey.platform,
    label: 'Platform Type',
    filter: PlatformFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  // TODO: temporary commented "campaignId" property (backend in progress)
  // {
  //     name: WelcomeTradingAccountFilterKey.accountType,
  //     label: 'Account Type',
  //     filter: TradingAccountTypeFilter,
  //     operators: [
  //          { text: GridFilterOperatorNameEnum.equalOperator, operator: GridFilterOperatorEnum.equalOperator },
  //          { text: GridFilterOperatorNameEnum.notEqOperator, operator: GridFilterOperatorEnum.notEqOperator },
  //     ],
  // },
  {
    name: WelcomeTradingAccountFilterKey.company,
    label: 'Tickmill Company',
    filter: MultiCompanySelectFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: WelcomeTradingAccountFilterKey.status,
    label: 'Status',
    filter: TradingAccountStatusFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: WelcomeTradingAccountFilterKey.country,
    label: 'Country',
    filter: CountryFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: TradingAccountFilterKey.createdDate,
    label: 'Date Created',
    filter: CustomDateFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOrEqualOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOrEqualOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
    ],
  },
  {
    name: TradingAccountFilterKey.isTradingViewConnected,
    label: 'Is TV Connected',
    filter: BooleanFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
]

export { getTradingAccountDemoFilterFields }
